import styled from 'styled-components';
import { mobileWidth } from '~/constants/metrics';

export const Holder = styled.div`
  padding: 12px;
  margin-top: 26px;
  text-align: center;

  .stats-title {
    color: ${({ theme }) => theme.textColorSecondary};
    font-size: 28px;
    font-weight: bold;
  }

  .stats-description {
    color: ${({ theme }) => theme.textColor};
  }
`;

export const ProductionDaysHolder = styled.div`
  padding: 12px;
  margin-top: 26px;
  text-align: center;
  border: 2px solid ${({ theme }) => theme.borderColorBase};
  border-radius: ${({ theme }) => theme.borderRadiusBase};

  @media (min-width: ${mobileWidth}) {
    & {
    }
  }
`;

export const Container = styled.div`
  text-align: center;
  .stats-title {
    color: ${({ theme }) => theme.textColorSecondary};
  }

  .stats-description {
    color: ${({ theme }) => theme.textColor};
    font-size: 22px;
    font-weight: bold;
  }
`;
